import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Result() {
  return (
    <section className="result_par p-100 text_color">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span style={{ color: "#5866FF" }}>Results</span>
            </h2>
            <p>
              MoodBe is an innovative and trendy dating app that enables users
              to match with other like-minded individuals. It has a match for
              everyone and that is why people seem to love it. Our algorithm
              makes sure that people will only match with those that share their
              same interests and moods. So someone looking for a casual
              relationship is not likely to be matched with someone joining the
              app with marriage in mind. We were able to capture and capitalize
              on this gap in the dating app market with MoodBe, which is why it
              has great reviews and ratings so far.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/moodbe/id6444644149">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.mood_be">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/moodbe/the_result.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={721}
                height={752}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
